export const workshopsData = [
  {
    points: [
      "Understand the importance of sample size in research design.",
      "Learn methods to calculate sample size for different study types.",
      "Avoid common errors in determining appropriate sample sizes.",
      "Gain hands-on experience with sample size calculation tools.",
    ],
    image: "/assets/images/workshop3.webp",
    video: "/assets/videos/biostatistics-workshop.mp4",
    url: "https://www.biostathouse.com/workshop/doctors_guide_for_biostatistics(501)",
  },
  {
    points: [
      "Master organizing and managing references efficiently.",
      "Learn to cite sources accurately in various formatting styles.",
      "Collaborate seamlessly on shared libraries for group projects.",
      "Automate reference insertion and formatting in research documents.",
    ],
    image: "/assets/images/workshop3.webp",
    url: "/workshops",
  },
  {
    points: [
      "Understand key statistical concepts and their applications in medical research.",
      "Analyze and interpret data effectively using statistical tools.",
      "Learn hypothesis testing and confidence intervals.",
      "Gain practical skills in presenting statistical results clearly.",
    ],
    image: "/assets/images/workshop3.webp",
    url: "",
  },
  {
    points: [
      "Understand the importance of sample size in research design.",
      "Learn methods to calculate sample size for different study types.",
      "Avoid common errors in determining appropriate sample sizes.",
      "Gain hands-on experience with sample size calculation tools.",
    ],
    image: "/assets/images/workshop3.webp",
    url: "/workshops",
  },
  {
    points: [
      "Master organizing and managing references efficiently.",
      "Learn to cite sources accurately in various formatting styles.",
      "Collaborate seamlessly on shared libraries for group projects.",
      "Automate reference insertion and formatting in research documents.",
    ],
    image: "/assets/images/workshop3.webp",
    url: "",
  },
  {
    points: [
      "Understand key statistical concepts and their applications in medical research.",
      "Analyze and interpret data effectively using statistical tools.",
      "Learn hypothesis testing and confidence intervals.",
      "Gain practical skills in presenting statistical results clearly.",
    ],
    image: "/assets/images/workshop3.webp",
    url: "/services/sample-size",
  },
];
